import React, { useContext } from "react";
import { I18nContext } from "../../../i18n";
import Async from "react-code-splitting";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "gatsby";




const SearchBar = () => <Async load={import("../../AC-Header/SearchHelper")} />;
const ServicesBox = () => {
  const { translate, langCode } = useContext(I18nContext);
  // const responsive = {
  //   superLargeDesktop: {
  //     // the naming can be any, depends on you.
  //     breakpoint: { max: 4000, min: 1600 },
  //     items: 5
  //   },
  //   desktop: {
  //     breakpoint: { max: 1600, min: 1360 },
  //     items: 5
  //   },
  //   mdDesktop: {
  //     breakpoint: { max: 1360, min: 1024 },
  //     items: 4
  //   },
  //   tablet: {
  //     breakpoint: { max: 1024, min: 768 },
  //     items: 3
  //   },
  //   mobile: {
  //     breakpoint: { max: 768, min: 520 },
  //     items: 2
  //   },
  //   xsMobile: {
  //     breakpoint: { max: 520, min: 0 },
  //     items: 1
  //   }
  // };
  return (
    <>
      <div className="cafe-banner-container" style={{
        marginTop: "10px"
      }}><div className="elementor-widget-container"><div className="cafe-banner normal cafe-overlay-content "><Link to="/shopping/mens"><div className="cafe-wrap-image"><img src="https://ik.imagekit.io/ofb/mall/shop_X3MyDdVIU.jpg" alt="Men's" /></div><div className="cafe-wrap-content"><h3 className="cafe-banner-title">SHOP</h3><div className="cafe-wrap-extend-content"><div className="cafe-banner-description"><p>Take advantage of the Click & Collect service available at your favourite stores.</p></div><span className="cafe-button">DISCOVER</span></div></div></Link></div></div><div className="elementor-widget-container"><div className="cafe-banner normal cafe-overlay-content "><Link to="/dining"><div className="cafe-wrap-image"><img src="https://ik.imagekit.io/ofb/mall/food_5NmxFDHTp.jpg" alt="DINE" /></div><div className="cafe-wrap-content"><h3 className="cafe-banner-title">DINE</h3><div className="cafe-wrap-extend-content"><div className="cafe-banner-description"><p>
      Indulge in a fine dining experience with a variety of cuisines for all food enthusiasts.</p></div><span className="cafe-button">DISCOVER</span></div></div></Link></div></div></div>

      
    </>
  );
};

export default ServicesBox;
